/**
 * Conversão de emoticons de texto → emoji (estilo Slack/WhatsApp).
 *
 * Regra de segurança: só converte um emoticon quando ele é um TOKEN inteiro
 * delimitado por espaço (ou início/fim). Assim `http://x` ou `8-)-ish` não
 * disparam conversão — apenas `:)`, `;-)`, `<3` isolados viram emoji.
 */

// Mapa emoticon → emoji. Variações com e sem nariz (`-`).
export const EMOTICON_MAP: Record<string, string> = {
  ':)': '🙂', ':-)': '🙂', '=)': '🙂', '(:': '🙂',
  ';)': '😉', ';-)': '😉',
  ':D': '😄', ':-D': '😄', '=D': '😄',
  ':(': '🙁', ':-(': '🙁', '=(': '🙁',
  ":'(": '😢', ":'-(": '😢',
  ':P': '😛', ':-P': '😛', ':p': '😛', ':-p': '😛',
  ':O': '😮', ':-O': '😮', ':o': '😮', ':-o': '😮',
  ':|': '😐', ':-|': '😐',
  ':*': '😘', ':-*': '😘',
  ':/': '😕', ':-/': '😕', ':\\': '😕',
  'B-)': '😎', '8-)': '😎', 'B)': '😎', '8)': '😎',
  'xD': '😆', 'XD': '😆', 'xd': '😆',
  ":')": '🥲', ":'-)": '🥲',
  '<3': '❤️', '</3': '💔',
  'o/': '👋', 'O/': '👋', '\\o': '👋',
  ':+1:': '👍', ':thumbsup:': '👍',
}

/** Converte TODOS os emoticons isolados (tokens) do texto. Usado no envio. */
export function convertEmoticonsAll(text: string): string {
  if (!text) return text
  // Split preservando os separadores (espaços/quebras) → cada token exato é
  // testado no mapa; separadores passam intactos.
  return text
    .split(/(\s+)/)
    .map((tok) => (Object.prototype.hasOwnProperty.call(EMOTICON_MAP, tok) ? EMOTICON_MAP[tok] : tok))
    .join('')
}

/**
 * Conversão "ao vivo": quando o usuário acaba de digitar um separador logo
 * após um emoticon completo, converte só esse token. Retorna o texto novo e a
 * posição de cursor ajustada, ou null se não houve conversão.
 *
 * @param raw    valor atual do textarea
 * @param cursor posição do cursor (selectionStart)
 */
export function convertEmoticonAtCursor(
  raw: string,
  cursor: number,
): { text: string; cursor: number } | null {
  const before = raw.slice(0, cursor)
  // token não-espaço seguido de UM separador, no fim do "before"
  const m = before.match(/(^|\s)(\S+)(\s)$/)
  if (!m) return null
  const tok = m[2]
  const emoji = Object.prototype.hasOwnProperty.call(EMOTICON_MAP, tok) ? EMOTICON_MAP[tok] : null
  if (!emoji) return null
  const sep = m[3]
  const tokenStart = cursor - (sep.length + tok.length)
  const text = raw.slice(0, tokenStart) + emoji + sep + raw.slice(cursor)
  return { text, cursor: tokenStart + emoji.length + sep.length }
}
